import VueScrollTo from 'vue-scrollto'

export default {
    methods: {
        navigateTo (target) {
            if (this.$route.name === target.name) {
                return this.scrollTo(target.hash)
            }

            this.$router.push(target)
        },

        scrollTo (selector) {
            const options = {
                container: 'body',
                easing: 'ease-out',
                offset: -100,
                force: true
            }

            this.$nextTick().then(() => {
                VueScrollTo.scrollTo(selector, 500, options)
            })
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixins/NavigateTo.js